import moment from 'moment/moment';
import { DateFormat, RELOAD_TIME_5_SECONDS } from 'utils/constants';
import { useEffect, useState } from 'react';

const Timer = () => {
  const [dateTime, setDateTime] = useState(moment());

  useEffect(() => {
    const timer = setInterval(
      () => setDateTime(moment()),
      RELOAD_TIME_5_SECONDS
    );

    return () => {
      clearInterval(timer);
    };
  }, []);

  return <>{dateTime.format(DateFormat.DATETIME_FORMAT_WITHOUT_SECONDS)}</>;
};

export default Timer;
